import React from 'react'
import { Redirect } from "react-router-dom";
import Header from './header';
import Footer from './footer';
import './style/userdash.css';

function UserAfterLogin() {
  let authuser = sessionStorage.getItem('Key_Veriable')
  console.log(authuser)
  if (authuser == null) { return (<Redirect to="/login" />)}
  else {
    let name = sessionStorage.getItem('name')
    console.log(name)
    return (
      <div >
        <Header />
        <br /><h3 className="this">WELCOME {name}</h3>
        <h3> RIDE UNLIMITED, FOR A FIXED PRICE</h3>
        <h3> Rent from India's Largest Fleet of Motorcycles, Trusted by millions.</h3>
        <h3>"If you ride like there's no tomorrow, there won't be."</h3>
        <h3 className="this">THIS IS USER DASH BOARD</h3>
        <Footer />
      </div>
    )
  }
};

export default UserAfterLogin
